import {SidebarReleases as ReleasesComponent} from '@github-ui/code-view-sidebar/components/SidebarReleases'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
  /** Total number of published releases (from the about payload). */
  releaseCount: number
  /** Total number of tags (from the about payload). */
  tagCount: number
}

export function SidebarReleases({ownerLogin, repoName, releaseCount, tagCount}: Props) {
  const {releases} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!releases) return null
  return <ReleasesComponent {...releases} releaseCount={releaseCount} tagCount={tagCount} />
}
